import { render } from "./VideoPlayerModal.vue?vue&type=template&id=f07ce54a&scoped=true"
import script from "./VideoPlayerModal.vue?vue&type=script&lang=js"
export * from "./VideoPlayerModal.vue?vue&type=script&lang=js"

import "./VideoPlayerModal.vue?vue&type=style&index=0&id=f07ce54a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f07ce54a"]])

export default __exports__